<div class="theme-picker">
  <button
    matIconButton
    class="theme-button"
    aria-label="Change theme"
    [matTooltip]="'settings.theme.change' | transloco"
    [matMenuTriggerFor]="themeMenu">
    <mat-icon>{{ themeModeIcon() }}</mat-icon>
  </button>

  <mat-menu #themeMenu="matMenu" class="theme-menu">
    <!-- Theme Modes -->
    <div class="theme-modes">
      <button
        mat-button
        class="theme-mode-button"
        [class.active]="currentTheme().mode === 'light'"
        (click)="setThemeMode('light')">
        <mat-icon>light_mode</mat-icon>
        <span>Light</span>
      </button>

      <button
        mat-button
        class="theme-mode-button"
        [class.active]="currentTheme().mode === 'system'"
        (click)="setThemeMode('system')">
        <mat-icon>settings_brightness</mat-icon>
        <span>Auto</span>
      </button>

      <button
        mat-button
        class="theme-mode-button"
        [class.active]="currentTheme().mode === 'dark'"
        (click)="setThemeMode('dark')">
        <mat-icon>dark_mode</mat-icon>
        <span>Dark</span>
      </button>
    </div>

    <mat-divider />

    <!-- Enforced Theme Notice -->
    @if (isEnforced) {
      <div class="enforced-theme-notice">
        <mat-icon>info</mat-icon>
        <span>{{ 'settings.theme.enforced' | transloco }}</span>
      </div>
    }

    <!-- Color Palettes -->
    <div class="theme-palettes-container">
      <div class="theme-palettes" [class.disabled]="isEnforced">
        @for (palette of palettes(); track palette.id) {
          <button
            class="palette-button"
            [disabled]="isEnforced && !isCurrentPalette(palette.id)"
            [class.active]="isCurrentPalette(palette.id)"
            [style.--preview-primary]="palette.primary"
            [style.--preview-secondary]="palette.secondary"
            [style.--preview-tertiary]="palette.tertiary"
            (click)="setPalette(palette)">
            <div class="palette-preview">
              <div class="color-dot primary"></div>
              <div class="color-dot secondary"></div>
              <div class="color-dot tertiary"></div>
            </div>
            <span class="palette-name">{{ palette.name }}</span>
          </button>
        }
      </div>
    </div>
  </mat-menu>
</div>
